// Comes back from ES
export enum AggregationTerm {
  FORMAT = 'format',
  SIMPLIFIED_VOICINGS = 'simplified_voicings',
  EXERCISE_FORMAT = 'exercise_format',
  GENRES = 'genres',
  INSTRUMENTS = 'instruments',
  DIFFICULTY = 'difficulty_level',
  DURATION = 'duration',
  OPENING_KEY = 'opening_key',
  MUSIC_SOURCE = 'music_type',
  GRADE_LEVELS = 'grade_levels',
}

export type Aggregation = {
  key: string
  doc_count: number
  from?: number
  to?: number
}

export type Aggregations = { [key in AggregationTerm]: Aggregation[] }

export type FilterOpts = {
  order: number | null
  translationPrefix?: string
}

export type FacetTerm = {
  key: string
  count: number
  selected?: boolean
}

export type Facet = {
  category: string
  terms: FacetTerm[]
} & FilterOpts

export enum MusicType {
  PREMIUM_CONTENT = 'Premium Content',
  ARRANGEME_CONTENT = 'ArrangeMe Content',
  COMMUNITY_SCORES = 'Community Scores',
  FREE_LIBRARY = 'Free Library',
  EE_BAND_BOOK1 = 'EE Band Book 1',
  EE_BAND_BOOK2 = 'EE Band Book 2',
  EE_BAND_BOOK3 = 'EE Band Book 3',
  EE_STRING_BOOK1 = 'EE String Book 1',
  EE_STRING_BOOK2 = 'EE String Book 2',
  EE_STRING_BOOK3 = 'EE String Book 3',
}

export enum Difficulty {
  BEGINNER = 10,
  INTERMEDIATE = 20,
  ADVANCED = 30,
}
